module.exports = __webpack_public_path__ + "static/img/ramp-8m-x-4m_256.65e4ed0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ramp-8m-x-4m_256.png
// module id = Dh5/
// module chunks = 0